import React from 'react';

import { Box } from '@mui/material';

import { useGlobalProducts } from 'components/BusinessToolForm/hooks/useGlobalProducts';
import { GLOBAL_PRODUCTS_NAME } from 'components/BusinessToolForm/Sections/Global/form';

import { concatWithDot } from 'helpers/string';

import { ProductVolumes } from './components/ProductVolumes';
import { ProductVolumesTable } from './components/ProductVolumesTable';
import { IProductionPlansAndSpecificsProps } from './types';
import { prefix, PRODUCTION_NAMES } from '../utils/form';

export const ProductionPlansAndSpecifics: React.FC<IProductionPlansAndSpecificsProps> = ({ disabled = false }) => {
  const { products, productionFields, handleAddProduct, handleRemoveProduct } = useGlobalProducts();

  const tableName = concatWithDot(prefix, PRODUCTION_NAMES.PLANNED_PRODUCTS_VOLUME);

  return (
    <Box>
      <ProductVolumes
        productsName={GLOBAL_PRODUCTS_NAME}
        fields={products}
        disabled={disabled}
        onAddRow={handleAddProduct}
        onRemoveRow={handleRemoveProduct}
      />

      <ProductVolumesTable tableName={tableName} fields={productionFields} disabled={disabled} />
    </Box>
  );
};
